module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h5 class="my-devices-title';
 if ( ! hasDevicesTitle ) { 
__p+=' hidden';
 } 
__p+='">'+
((__t=( i18n.tc( "UnitContainer", "My devices" ) ))==null?'':__t)+
'</h5><div data-region="unit-info"></div><div data-region="unit-container"></div>';
}
return __p;
};
